angular.module('charts')
    .directive('dblAssignFocusAd', [function() {

    return {
        restrict: 'E',
        scope: {
          busy:"=?",
          assignments:"=?"
        },
        templateUrl: '/resources/charts/directives/assign-focus-ad/dbl-assign-focus-ad.directive.html'
    };
}]);
